import { render } from "./MarksProducts.vue?vue&type=template&id=3a0a74d8&scoped=true"
import script from "./MarksProducts.vue?vue&type=script&lang=js"
export * from "./MarksProducts.vue?vue&type=script&lang=js"

import "./MarksProducts.vue?vue&type=style&index=0&id=3a0a74d8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a0a74d8"]])

export default __exports__